import TeamReviewsComponent from "@/components/reviews";

export default function TeamReviews() {
  return <TeamReviewsComponent />;
}
